/**
 * @generated SignedSource<<5358fb5a748e4ba7f31137caa6dc626d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedSinglePostForm_brand$data = {
  readonly feed: {
    readonly id: string;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"CDPAudienceSelectorCard_brand" | "useFeedPostCreateMutation_brand" | "useFeedPostUpdateMutation_brand">;
  readonly " $fragmentType": "FeedSinglePostForm_brand";
};
export type FeedSinglePostForm_brand$key = {
  readonly " $data"?: FeedSinglePostForm_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedSinglePostForm_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedSinglePostForm_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLFeed",
      "kind": "LinkedField",
      "name": "feed",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFeedPostCreateMutation_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFeedPostUpdateMutation_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CDPAudienceSelectorCard_brand"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "45db75bfce0a86a327e9310b8866e55d";

export default node;
